import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _ABTEST$ACCORDION$ACC;

// This file provides node rules for structured-content JSON document
import { ABTEST, ACCORDION, ACCORDIONITEM, ADVERTISERDISCLOSURE, ANCHORLINK, ANCHORLINKTARGET, APOLLOINTEGRATIONCANARY, ARTICLEHERO, AUTHLINK, AUTHORSBOX, AUTOINSURANCEBANNER, AUTOINSURANCEDRCFIELD, AUTOINSURANCEDRCPROVIDER, AUTOINSURANCEENTRYPOINT, AUTOINSURANCEQUOTES, BACKTOTOPLINK, BANNER, BUTTON, CALCULATEDFIELDSFORM, CALCULATION, CALCULATOR, CALCULATORCONDITIONAL, CALCULATORINPUT, CALCULATORRADIO, CALCULATORSELECT, CITATION, CITATIONLIST, COLUMN, COLUMNS, CONTAINER, CONTENTHEADING, CONTENTPAGEHEADER, CONTENTIMAGE, CONTENTQUOTE, CREDITCARDSABOVESECTIONS, CREDITCARDSROUNDUPSUMMARYTABLE, DIVIDER, DOCUMENT, DROPCAPS, FAQ, FUNDERALOANOPTIONCTA, HEADING, HIGHLIGHTSLIST, HLMENTRY, HLMGENERICENTRY, HLMREFINANCEENTRY, HOMEINSURANCEBANNER, HOMEINSURANCEENTRYPOINT, HOUSEAD, IMAGE, INFOGRAM, INSTAGRAM, LENDINGPRODUCTCARD, LIFEINSURANCEBANNER, LINK, LIST, LISTITEM, LOANESTIMATEENTRYPOINT, LOCATIONDATAFIELD, LOCATIONDATAPROVIDER, LOGOSROW, MARKETPLACEAPPLYNOW, MARKETPLACECOMPARISONLINK, MARKETPLACECOMPARISONTABLE, MARKETPLACEENTITYLOGOROW, MARKETPLACEENTRYPOINT, MARKETPLACEFIELD, MARKETPLACEPARTNERPLACEMENT, MARKETPLACEPRODUCTCARD, CREDITCARDSMARKETPLACEPRODUCTCARD, MARKETPLACESTARRATING, MARKETPLACERATETABLE, MARKETPLACETHIRDPARTYEMBED, MEGAPHONEFM, MINIPRODUCTCARD, MORELINK, MORTGAGELENDERINTERACTIVECOMPARISON, NERDTIP, NOOP, OUTOFDATEMESSAGE, POSTLIST, PREQUALAPPLICATIONHOUSEAD, PREQUALBANNER, PRODUCTSTARRATING, RENDERCONTEXTCONDITIONAL, RENTERSINSURANCEENTRYPOINT, REVIEWDETAILSOFFER, REVIEWINTROOFFER, REVIEWJSONLD, CREDITCARDSROUNDUPCATEGORYSECTION, ROUNDUPJSONLD, SCREENSIZECONDITIONAL, SCROLLDEPTHCONDITIONAL, SOCIALMEDIALINKS, SPOTIFY, STARRATING, TABLE, TABLEOFCONTENTS, TIKTOK, TITLE, TWITTER, TYPE, VIDEO, USERSEGMENTCONDITIONAL, WELL, WPAUTHORSBOX, WPBIOHEADER, WPBLOCK, WPCALCULATOR, WPCONTENTPAGEHEADER, WPEMBED, WPFEATUREDIMAGE, WPHOUSEAD, WPINLINEBLOCK, WPMARKETPLACEENTRYPOINT, WPMETHODOLOGY, WPPOSTLIST, WPSOCIALMEDIALINKS, WPTABLE, TABLEOFCONTENTSTARGET, MARKETPLACEENTITYDISPLAYNAME, STICKYCONTAINER } from './types'; // eslint-disable-next-line camelcase

import migrateColumnsFrom_1_0_0_to_2_0_0 from './components/columns/migrations/2.0.0'; // eslint-disable-next-line camelcase

import migrateWpPostListFrom_1_0_0_to_2_0_0 from './components/wp-post-list/migrations/2.0.0';
export default (_ABTEST$ACCORDION$ACC = {}, _defineProperty(_ABTEST$ACCORDION$ACC, ABTEST, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, ACCORDION, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, ACCORDIONITEM, {
  nodeProps: ['children', 'label', 'labelCollapsed'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, ADVERTISERDISCLOSURE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, ANCHORLINK, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, ANCHORLINKTARGET, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, APOLLOINTEGRATIONCANARY, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, ARTICLEHERO, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, AUTHLINK, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, AUTHORSBOX, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, AUTOINSURANCEBANNER, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, AUTOINSURANCEDRCFIELD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, AUTOINSURANCEDRCPROVIDER, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, AUTOINSURANCEENTRYPOINT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, AUTOINSURANCEQUOTES, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, BACKTOTOPLINK, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, BANNER, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, BUTTON, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CALCULATEDFIELDSFORM, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CALCULATION, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CALCULATOR, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CALCULATORCONDITIONAL, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CALCULATORINPUT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CALCULATORRADIO, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CALCULATORSELECT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CITATION, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CITATIONLIST, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, COLUMN, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, COLUMNS, {
  nodeProps: ['children'],
  version: '2.0.0',
  migrations: {
    '2.0.0': migrateColumnsFrom_1_0_0_to_2_0_0
  }
}), _defineProperty(_ABTEST$ACCORDION$ACC, CONTAINER, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CONTENTHEADING, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CONTENTPAGEHEADER, {
  nodeProps: ['synopsis'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CONTENTIMAGE, {
  nodeProps: ['children', 'caption'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CONTENTQUOTE, {
  nodeProps: ['children', 'author', 'authorTitle'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CREDITCARDSABOVESECTIONS, {
  nodeProps: ['aboveSections'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CREDITCARDSROUNDUPSUMMARYTABLE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, DIVIDER, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, DOCUMENT, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, DROPCAPS, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, FAQ, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, FUNDERALOANOPTIONCTA, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, HEADING, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, HIGHLIGHTSLIST, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, HLMENTRY, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, HLMGENERICENTRY, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, HLMREFINANCEENTRY, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, HOMEINSURANCEBANNER, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, HOMEINSURANCEENTRYPOINT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, HOUSEAD, {
  nodeProps: ['ctaNode'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, IMAGE, {
  nodeProps: ['children', 'caption'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, INFOGRAM, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, INSTAGRAM, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, LENDINGPRODUCTCARD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, LIFEINSURANCEBANNER, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, LINK, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, LIST, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, LISTITEM, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, LOANESTIMATEENTRYPOINT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, LOCATIONDATAFIELD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, LOCATIONDATAPROVIDER, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, LOGOSROW, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MARKETPLACEAPPLYNOW, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MARKETPLACECOMPARISONLINK, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MARKETPLACECOMPARISONTABLE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MARKETPLACEENTITYDISPLAYNAME, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MARKETPLACEENTITYLOGOROW, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MARKETPLACEENTRYPOINT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MARKETPLACEFIELD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MARKETPLACEPARTNERPLACEMENT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MARKETPLACEPRODUCTCARD, {
  nodeProps: ['bottomLine'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CREDITCARDSMARKETPLACEPRODUCTCARD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MARKETPLACESTARRATING, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MARKETPLACERATETABLE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MARKETPLACETHIRDPARTYEMBED, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MEGAPHONEFM, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MINIPRODUCTCARD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MORELINK, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, MORTGAGELENDERINTERACTIVECOMPARISON, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, NERDTIP, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, NOOP, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, OUTOFDATEMESSAGE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, POSTLIST, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, PREQUALAPPLICATIONHOUSEAD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, PREQUALBANNER, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, PRODUCTSTARRATING, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, RENDERCONTEXTCONDITIONAL, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, RENTERSINSURANCEENTRYPOINT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, REVIEWDETAILSOFFER, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, REVIEWINTROOFFER, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, REVIEWJSONLD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, CREDITCARDSROUNDUPCATEGORYSECTION, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, ROUNDUPJSONLD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, SCREENSIZECONDITIONAL, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, SCROLLDEPTHCONDITIONAL, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, SOCIALMEDIALINKS, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, SPOTIFY, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, STARRATING, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, STICKYCONTAINER, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, TABLE, {
  nodeProps: ['columns.*.heading', 'data.*.cells.*'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, TABLEOFCONTENTS, {
  nodeProps: ['items.*.title'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, TABLEOFCONTENTSTARGET, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, TIKTOK, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, TITLE, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, TWITTER, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, TYPE, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, VIDEO, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, USERSEGMENTCONDITIONAL, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, WELL, {
  nodeProps: ['children'],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, WPAUTHORSBOX, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, WPBIOHEADER, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, WPBLOCK, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, WPCALCULATOR, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, WPCONTENTPAGEHEADER, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, WPEMBED, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, WPFEATUREDIMAGE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, WPHOUSEAD, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, WPINLINEBLOCK, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, WPMARKETPLACEENTRYPOINT, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, WPMETHODOLOGY, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, WPPOSTLIST, {
  nodeProps: [],
  version: '2.0.0',
  migrations: {
    '2.0.0': migrateWpPostListFrom_1_0_0_to_2_0_0
  }
}), _defineProperty(_ABTEST$ACCORDION$ACC, WPSOCIALMEDIALINKS, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _defineProperty(_ABTEST$ACCORDION$ACC, WPTABLE, {
  nodeProps: [],
  version: '1.0.0',
  migrations: {}
}), _ABTEST$ACCORDION$ACC);